import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
} from '@mui/material';
import { decryptData } from '../../services/cryptoUtils';
import images from '../../services/logoLoader';

function SelecaoMatriz() {
  const { user, selectCompany } = useAuth();
  const navigate = useNavigate();
  const [filter, setFilter] = useState('');

  // Descriptografa e obtém a lista de empresas disponíveis
  const companies = user.matrizFilialDisponivel|| [];

  // Filtra as empresas de acordo com a descrição
  const filteredCompanies = companies.filter((company) =>
    company.descricaoFilial.toLowerCase().includes(filter.toLowerCase())
  );

  // Background importado (deve estar em src/assets/logos/login-bg.jpg)
  const background = images['login-bg.jpg'];

  const handleSelect = (company) => {
    selectCompany(company);
    navigate('/home');
  };

  return (
    <Box
      sx={{
        background: `url(${background}) no-repeat center center`,
        backgroundSize: 'cover',
        minHeight: '100vh',
        p: { xs: 2, md: 4 },
      }}
    >
      {/* Overlay para melhorar o contraste */}
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          borderRadius: 2,
          p: { xs: 2, md: 4 },
          maxWidth: 1200,
          mx: 'auto',
        }}
      >
        <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 600 }}>
          Selecione a Empresa
        </Typography>
        <Typography variant="subtitle1" align="center" color="textSecondary" gutterBottom>
          Escolha a empresa na qual você deseja trabalhar
        </Typography>

        {/* Campo de filtro */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <TextField
            label="Filtrar por descrição"
            variant="outlined"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            sx={{ width: '100%', maxWidth: 400 }}
          />
        </Box>

        {filteredCompanies.length === 0 ? (
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6" color="error">
              Nenhuma empresa disponível para seleção.
            </Typography>
          </Box>
        ) : (
          // Container flexível para simular carrossel
          <Box sx={{ display: 'flex', overflowX: 'auto', mt: 2, pb: 2 }}>
            {filteredCompanies.map((company, index) => {
              const fileName = company.logo;
              // Busca o logo no objeto de imagens; se não existir, usa um fallback
              const logoSrc = images[fileName] || images['default.png'];

              return (
                <Box key={index} sx={{ minWidth: 300, mr: 2, flexShrink: 0 }}>
                  <Card elevation={3} sx={{ borderRadius: 2 }}>
                    <CardActionArea onClick={() => handleSelect(company)}>
                      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
                        <CardMedia
                          component="img"
                          image={logoSrc}
                          alt={company.descricaoFilial}
                          sx={{
                            width: 100,
                            height: 100,
                            objectFit: 'contain',
                            borderRadius: '50%',
                            border: '2px solid #ddd',
                          }}
                        />
                      </Box>
                      <CardContent sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 500 }}>
                          {company.descricaoFilial}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default SelecaoMatriz;
